import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

import { replace } from 'ramda';

@Directive()
export abstract class InputBaseComponent {
  @Input() value: any;

  @Output() pulseBlur = new EventEmitter<any>();
  @Output() pulseChange = new EventEmitter<any>();
  @Output() pulseFocus: EventEmitter<FocusEvent> =
    new EventEmitter<FocusEvent>();
  @Output() pulseInput: EventEmitter<any> = new EventEmitter<any>();
  @Output() pulseClearInput: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('inputNative') inputNative: ElementRef;

  private clearInputLast = false;

  // tslint:disable-next-line: completed-docs
  @HostListener('keypress', ['$event'])
  handleChangeKeypressEvent(event: any) {
    this.validateRegex(event);
  }

  constructor(protected el: ElementRef) {}

  @Input() maxLength: number;
  /**
   * Gets and sets value of regex.
   */
  @Input()
  get regex() {
    return this.lastRegex;
  }

  set regex(value: any) {
    if (this.lastRegex !== value) {
      this.lastRegex = value;
    }
  }

  private lastRegex = undefined;

  isDisabled: boolean;

  onTouch = () => {};

  onChange = (value: any) => {
    this.pulseChange.emit(value);
  };

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(obj: any): void {
    if (obj) {
      this.value = obj || '';
    } else {
      this.value = '';
    }
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onInput(event: any) {
    this.value = event.target.value;
    this.onTouch();
    this.onChange(this.value);
  }

  @Input()
  get clearInput(): boolean {
    return this.clearInputLast;
  }

  clearTextInput(): void {
    const { nativeElement } = this.inputNative;
    nativeElement.value = '';

    this.pulseChange.emit({ value: '' });
    this.pulseClearInput.emit();
  }

  private validateRegexInput(event: any): void {
    if (
      this.regex ||
      event.inputType == 'insertText' ||
      event.inputType == 'insertCompositionText'
    ) {
      this.matchRegex(event.data, event);
    }
  }

  /**
   * Listens event and validates the value typed.
   */
  private validateRegex(event: any): void {
    if (this.regex && event.type === 'paste') {
      const clipboardData =
        event.clipboardData || (window as any).clipboardData;
      this.matchRegex(clipboardData.getData('text'), event, 'paste');
    } else if (this.regex && event.key !== 'Enter') {
      this.matchRegex(event.key, event);
    }
  }

  /**
   * Match regex.
   */
  matchRegex(value: any, event: any, type = 'default') {
    const newRegex = new RegExp(this.regex, 'g');

    const match = String(value).match(newRegex);
    if (match) {
      if (!value) {
        value = '';
      }
      const cleanText = replace(newRegex, '', value);
      if (type === 'paste') {
        const shorted = this.maxLength
          ? cleanText.substring(0, this.maxLength)
          : cleanText;
        this.updateValue(shorted);
      }
      if (
        event.inputType == 'insertText' ||
        event.inputType == 'insertCompositionText'
      ) {
        const valueInput =
          this.el.nativeElement.querySelector('input, textarea').value;
        const filteredText = replace(newRegex, '', valueInput);
        this.el.nativeElement.querySelector('input, textarea').value =
          filteredText;
      }
      event.stopPropagation();
      event.preventDefault
        ? event.preventDefault()
        : (event.returnValue = false);
      return false;
    }
    return null;
  }

  /**
   * Update of the value <input> and control the value.
   */
  private updateValue(value: any): void {
    const inputNative = this.el.nativeElement.querySelector('input, textarea');

    if (inputNative) {
      this.pulseChange.emit({ value: inputNative.value });
    }
  }
}
